<template>
  <div class="content">
    <div>
      <div class="data-fetch-error" v-show="dataFetchError">
        <p>Unable to fetch required data. Please try again.</p>
      </div>
    </div>

    <div class="employee-name">
      <router-link to="/payroll">Payroll History &raquo; </router-link>
      <a>{{ payrollTitle }}</a>
    </div>
    <div class="payout-title">
      <h2>Payout Transactions</h2>
    </div>

    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="table-form" v-show="!pageLoading">
      <table class="table">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Account&nbsp;Name</th>
            <th>Account&nbsp;Number</th>
            <th>Bank&nbsp;Name</th>
            <th>Amount</th>
            <th>Fee</th>
            <th>Status</th>
            <th>SESSION&nbsp;ID</th>
            <th>Attempts</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr class="batch" v-for="(transaction, index) in transactions" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ transaction.account_name }}</td>
            <td>{{ transaction.account_number }}</td>
            <td>{{ transaction.bank_name }}</td>
            <td>&#8358;{{ transaction.amount }}</td>
            <td>&#8358;{{ transaction.total_fee }}</td>
            <td>{{ transaction.status }}</td>
            <td>{{ transaction.provider_reference }}</td>
            <td>{{ transaction.transaction_attempts }}</td>
            <td>{{ createdDate(transaction.created_at) }}</td>
            <td>
              <div v-if="transaction.can_retry">
                <div v-show="!transaction.retrying"
                  @click="retryTransaction(index, transaction.uuid, transaction.payroll_id)" class="button-41">
                  <div>Retry</div>
                </div>
                <div v-show="transaction.retrying" class="payroll__setting--loader">
                  <WhiteLoader />
                </div>
              </div>


            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import BlueLoader from "../../partials/blue-loader";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

import { valueToCurrency, currencyToNumber } from "../../../util/filters";

import PageLoader from "../../partials/page-loader";

export default {
  name: "payrollDetails",
  components: {
    BlueLoader,
    PageLoader,
    WhiteLoader,
  },

  data() {
    return {
      pageLoading: true,
      transactions: [],
      payrollId: "",
      dataFetchError: false,
      payrollTitle: "",
    };
  },

  computed: {},

  created() {
    this.payrollId = this.$route.params.id;

    this.getPayroll(this.payrollId);
  },

  methods: {
    getPayroll(payrollId) {
      this.$http
        .get(types.GET_PAYROLL + `/${this.payrollId}`)
        .then((resp) => {
          this.payrollTitle = resp.data.data.title;

          this.getPayrollTransactions();
        })
        .catch((err) => { });
    },
    createdDate(dateString) {
      const date = new Date(dateString);
      const options = {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return date.toLocaleString("en-US", options);
    },
    getPayrollTransactions() {
      this.$http
        .get(types.PAYROLL_TRANSACTION_DETAILS + `/${this.payrollId}`)
        .then((resp) => {

          this.transactions = resp.data.data.transactions.data.map(transaction => ({
            ...transaction,
            retrying: false
          }));

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    validate() {
      let updateData = this.updateData();
      function trim(updateData) {
        for (var key in updateData) {
          if (typeof updateData[key] === "string") {
            const value = updateData[key].trim();

            if (!value) {
              this.emptyFields.push(key);
            }
            updateData[key] = value;
          }

          if (typeof updateData[key] === "object") {
            trim(updateData[key]);
          }
        }
      }

      trim(updateData);
      return updateData;
    },
    retryTransaction(index, transaction_uuid, payroll_id) {

      this.transactions[index].retrying = true;


      this.$http
        .post(types.RETRY_TRANSACTION, {
          transaction_uuid: transaction_uuid,
          payroll_id: payroll_id
        })
        .then((resp) => {
          this.transactions[index].status = "QUEUED";
          this.transactions[index].provider_reference = "";
          this.transactions[index].transaction_attempts = this.transactions[index].transaction_attempts + 1;
        })
        .catch((err) => {
          this.transactions[index].retrying = false;
        });
    }
  },

  filters: {
    valueToCurrency,
    currencyToNumber,
  },
};
</script>

<style lang="scss" scoped>
.button-41 {
  background: #5099de;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: Inter, -apple-system, system-ui, Roboto, "Helvetica Neue", Arial,
    sans-serif;
  height: 44px;
  line-height: 44px;
  outline: 0;
  overflow: hidden;
  padding: 0 10px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100%;
  z-index: 9;
  border: 0;
}

.button-41:hover {
  background: #004262;
}

.content {
  padding-top: 31.5px;
  padding-bottom: 100px;
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 2rem;
  }

  .page-loader {
    margin-top: 50px;

    >div {
      width: 55px;
      margin: auto;
    }
  }

  .payout-title {
    height: 35px;
    color: #302f2f;
    display: flex;
    border-bottom: 1px solid #ebe4e4;
    margin-top: 25px;

    h2 {
      font-size: 1rem;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: left;
    }
  }
}

.table-form {
  margin-top: 20px;
  padding-bottom: 15px;

  @media (max-width: 768px) {
    overflow: scroll;
    padding: 1rem;
  }

  table {
    // width: 980px;
    border-collapse: separate;
    border-spacing: 0 1em;

    thead th {
      border: none;
      line-height: 2px;
      font-size: 1rem;
    }

    tr>th:first-child {
      padding-left: 40px;
      padding-right: 0px;
    }

    tbody tr:first-child>td {
      border-top: 3px solid #5099de;
    }

    tr>td:first-child {
      padding-left: 42px;
      padding-right: 0px;
    }

    tr>td:last-of-type {
      padding-right: 60px;
    }

    tr>th:nth-of-type(2) {
      padding-right: 50px;
      padding-left: 0px;
    }

    tr>td:nth-of-type(2) {
      padding-right: 50px;
      padding-left: 0px;
    }

    tr>th:nth-of-type(4) {
      padding-right: 50px;
      padding-left: 20px;
    }

    tr>td:nth-of-type(4) {
      padding-right: 50px;
      padding-left: 20px;
    }

    tr>th:nth-of-type(5) {
      padding-left: 30px;
    }

    tr>td:nth-of-type(5) {
      padding-left: 30px;
    }

    th {
      width: 20%;
      font-size: 1rem;
    }

    input {
      border: none;
    }

    td {
      width: 20%;
      padding-top: 17px;
      font-size: 1rem;
    }

    tr.batch {
      height: 60px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      font-weight: 500;
      font-size: 1rem;
      color: #000;

      button {
        background-color: #1ec4b4;
        font-size: 0.9rem;
        padding: 3px;
        border-color: #1ec4b4;
        width: 80px;
      }

      span {
        font-weight: normal;
        font-size: 1rem;
        padding: 8px;
        color: #fff !important;
      }
    }
  }
}
</style>
